var map = {
	"./CQ.png": 160,
	"./KU.png": 161,
	"./KUl.svg.png": 162,
	"./address_image.svg": 163,
	"./aisweden_logo.png": 164,
	"./animated_logo.svg": 165,
	"./blogs_image.svg": 166,
	"./cloud_infrastructure.svg": 167,
	"./codeInLogo.png": 168,
	"./contactMail.png": 169,
	"./coursera_logo.png": 170,
	"./data_science.svg": 171,
	"./deeplearning_ai_logo.png": 172,
	"./delhivery_logo.png": 173,
	"./developerActivity.svg": 174,
	"./dsc_logo.png": 175,
	"./dsu_logo.svg": 176,
	"./education.svg": 177,
	"./experience.svg": 178,
	"./feelingProud.png": 94,
	"./feelingProud.svg": 179,
	"./feelingProud2.svg": 180,
	"./flutter.png": 181,
	"./flyinglabs_logo.png": 182,
	"./freecopy_logo.png": 183,
	"./fullstack.svg": 184,
	"./gcp_logo.png": 185,
	"./github.png": 186,
	"./github_logo.png": 187,
	"./googleAssistant.jpg": 188,
	"./googleAssistant.svg": 189,
	"./google_logo.png": 190,
	"./ibm_logo.png": 191,
	"./intel_logo.jpg": 192,
	"./jsFramework.svg": 193,
	"./legato_logo.png": 194,
	"./manOnTable.svg": 195,
	"./me.png": 196,
	"./microsoft_logo.png": 197,
	"./mozilla_logo.png": 198,
	"./muffito_logo.png": 199,
	"./navyajpeg.png": 200,
	"./nextuLogo.jpg": 201,
	"./nptel_logo.png": 202,
	"./programmer.svg": 203,
	"./projects/book.png": 83,
	"./projects/jupyter.png": 204,
	"./projects/postgresql.svg": 205,
	"./projects/python.png": 206,
	"./projects/pytorch.svg": 207,
	"./projects/react.svg": 208,
	"./projects/supabase.svg": 209,
	"./projects/typescript.svg": 210,
	"./projects_image.svg": 211,
	"./pwa.png": 212,
	"./python.png": 213,
	"./rainbow.jpg": 214,
	"./saayaHealthLogo.png": 215,
	"./salesforce.png": 216,
	"./sandeep.jpg": 217,
	"./school.jpg": 218,
	"./school.png": 219,
	"./stanford_logo.png": 220,
	"./talksCardBack.svg": 221,
	"./talksCardBackAlt.svg": 222,
	"./ui_ux_design.svg": 223,
	"./unnamed.jpg": 224
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47;